import { useState } from 'react';
import { Button } from '@kop/ui';
import type { AuthenticatedSession } from './auth/types';
import { headquartersSiteChoices } from './headquarters-site-navigation';
import './headquarters-site-switcher.css';

export function HeadquartersSiteSwitcher({ session, onSelect }: {
  session: AuthenticatedSession;
  onSelect: (scopeId: string) => Promise<void>;
}) {
  const choices = headquartersSiteChoices(session);
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);
  if (!choices.length) return null;
  const headquarters = choices[0]!;
  const select = async (scopeId: string) => {
    if (pending || scopeId === session.activeScopeId) return;
    setPending(true);
    setFailed(false);
    try {
      await onSelect(scopeId);
    } catch {
      setFailed(true);
    } finally {
      setPending(false);
    }
  };
  return (
    <div className="headquarters-site-switcher">
      <select
        aria-label="조회 사업장"
        value={session.activeScopeId}
        disabled={pending}
        onChange={(event) => void select(event.target.value)}
      >
        {choices.map((scope) => (
          <option key={scope.id} value={scope.id}>
            {scope.resource.kind === 'tenant' ? '본사 종합현황' : scope.label}
          </option>
        ))}
      </select>
      {session.activeScopeId !== headquarters.id && (
        <Button variant="quiet" disabled={pending} onClick={() => void select(headquarters.id)}>
          본사로
        </Button>
      )}
      {failed && <span className="headquarters-site-switcher-error" role="alert">전환하지 못했습니다. 다시 선택해 주세요.</span>}
    </div>
  );
}
